import { AccountDataEvent, StateEvent } from '$lib/enums';
import { NAV_REQUIRED_STATE } from './sliding-sync.constants';

export const ROOM_CACHE_DB_NAME = 'room-list-cache';
export const ROOM_CACHE_DB_VERSION = 1;
export const ROOM_CACHE_ROOM_STORE = 'rooms';
export const ROOM_CACHE_META_STORE = 'meta';
/** Bump when the cached shape changes; snapshots written by another shape are discarded. */
export const ROOM_CACHE_SCHEMA = 1;
export const ROOM_CACHE_FLUSH_MS = 3_000;

/**
 * Nav state worth keeping between sessions. Room emotes are left out: packs are large and only
 * the emoji board reads them, by which time the room has been synced.
 */
export const ROOM_CACHE_STATE_TYPES: ReadonlySet<string> = new Set(
	NAV_REQUIRED_STATE.flatMap(([type]) =>
		type && type !== StateEvent.PONIES_ROOM_EMOTES ? [type] : []
	)
);

/** Account data the nav reads before the first response: direct rooms and the sidebar layout. */
export const ROOM_CACHE_ACCOUNT_DATA_TYPES: readonly AccountDataEvent[] = [
	AccountDataEvent.DIRECT,
	AccountDataEvent.CINNY_SPACES
];
